import { render, staticRenderFns } from "./FormServices.vue?vue&type=template&id=5f10d6bd&scoped=true&"
import script from "./FormServices.vue?vue&type=script&lang=js&"
export * from "./FormServices.vue?vue&type=script&lang=js&"
import style0 from "./FormServices.vue?vue&type=style&index=0&id=5f10d6bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f10d6bd",
  null
  
)

export default component.exports